import React from 'react'
import { Button } from '@/components/common/UI/Button'

type Provider = 'google' | 'vk' | 'github' | 'yandex'

const providers: Array<{ id: Provider; label: string }> = [
  { id: 'google', label: 'Google' },
  { id: 'vk', label: 'ВКонтакте' },
  { id: 'github', label: 'GitHub' },
  { id: 'yandex', label: 'Яндекс ID' },
]

export const SocialLoginButtons: React.FC<{ role?: 'candidate' | 'employer' }> = ({ role = 'candidate' }) => {
  const startLogin = (provider: Provider) => {
    const apiUrl = (import.meta.env.VITE_API_URL || '/api').replace(/\/$/, '')
    window.location.assign(`${apiUrl}/v1/auth/oauth/${provider}?role=${role}`)
  }

  return (
    <div className="mt-4 grid grid-cols-2 gap-3">
      {providers.map(({ id, label }) => (
        <Button key={id} type="button" variant="outline" fullWidth onClick={() => startLogin(id)}>
          {label}
        </Button>
      ))}
    </div>
  )
}
